module.exports = __webpack_public_path__ + "static/img/bg-ar.8c8c7b2e.png";